export const styles = {
  container: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 1.5,
    width: "fit-content",
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  badge: (badgeColor, badgeText) => (theme) => {
    const textLength = typeof badgeText === "string" ? badgeText.length : 0
    const fontSize = textLength > 2 ? 12 : 15
    return {
      width: 36,
      height: 36,
      borderRadius: "8px",
      backgroundColor: badgeColor || theme.palette.primary.main,
      color: theme.palette.common.white,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 700,
      fontSize,
      flexShrink: 0,
      lineHeight: 1,
      overflow: "hidden",
    }
  },
  emojiContainer: (count) => (theme) => ({
    display: "flex",
    flexWrap: count >= 3 ? "wrap" : "nowrap",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    width: "100%",
    height: "100%",
    padding: "2px",
    boxSizing: "border-box",
    lineHeight: 1,
    gap: count >= 2 ? "1px" : undefined,
  }),
  emojiItem: (count) => (theme) => ({
    lineHeight: 1,
    textAlign: "center",
    fontSize: count === 1 ? "20px" : count === 2 ? "13px" : "11px",
    width: count >= 3 ? "45%" : undefined,
  }),
  textContainer: {
    display: "flex",
    flexDirection: "column",
  },
  title: (titleColor) => (theme) => ({
    color: titleColor,
    lineHeight: 1.2,
  }),
  subtitle: (theme) => ({
    color: theme.palette.text.secondary,
    mt: 0.25,
  }),
  divider: (dividerColor) => (theme) => ({
    height: 2,
    width: "100%",
    backgroundColor: dividerColor || theme.palette.divider,
    borderRadius: "1px",
  }),
}
